import { ChangeEvent, InputHTMLAttributes } from 'react';

export enum INPUT_STATE {
  DEFAULT = 'default',
  ERROR = 'error',
  SUCCESS = 'success',
}

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  validMessage?: string | null;
  label?: string;
  hint?: string;
  name: string;
  transform?: {
    input?: (value: any) => string;
    output?: (event: ChangeEvent<HTMLInputElement>) => ChangeEvent<HTMLInputElement>;
  };
  icon?: string;
}

export type HTMLInputProps = InputHTMLAttributes<HTMLInputElement> & {
  state?: INPUT_STATE;
};
